<template>
    <el-drawer
            :title="$t('subscription')"
            :before-close="closeHandle"
            v-if="mamSubscrpitDialogShow"
            :visible="mamSubscrpitDialogShow"
            direction="rtl"
            custom-class="copy-shell"
            :show-close="true"
            :close-on-press-escape="true"
            ref="drawer"
    >
        <div class="drawer-content pr"
             :class="{ 'need-pass': passFlag == true }"
        >
            <el-scrollbar style="height: 100%;"> <!-- 滚动条 -->
                <div class="subscript-box pr">
                    <div class="mam">
                        <div class="first-step"
                             v-show="step == 1"
                        >
                            <div class="mam-title copytype-title fs12">MAM{{$t('Master_account_special')}}</div>
                            <div class="mam-info">
                                <div class="nickname">{{alias}}</div>
                                <div class="money-limit fs12 space-between-text-middle-dotted-line">
                                    <span class="span-el">{{$t('Minimum_funding_limit')}}</span>
                                    <span class="line"></span>
                                    <span class="span-el">${{moneyLimit || 0}}</span>
                                </div>
                            </div>
                            <el-form
                                    ref="mamform"
                                    :model="mamForm"
                                    :rules="mamRules"
                            >
                                <el-form-item prop="mamMt4">
                                    <p class="self-label fs12">MAM {{$t('Investment_account')}}</p>
                                    <el-select
                                            :placeholder="$t('please_choose')"
                                            style="width: 100%"
                                            class="custom-select"
                                            v-model="mamForm.mamMt4"
                                    >
                                        <el-option v-for="(item,index) in mamAccountList"
                                                :key="index"
                                                :label="item.copyLogin"
                                                :value="item.copyMtId"
                                                   class="self-option-item"
                                        >
                                            <div class="self-option">
                                                <div class="self-option-left">
                                                    <div class="alias">{{item.copyAlias || '#' + item.copyLogin}}</div>
                                                    <div class="login">{{item.copyLogin}}</div>
                                                </div>
                                                <div class="self-option-right">
                                                    <span class="displayIb option-tag tag fs12">{{$t('MAM_Investment_Account')}}</span>
                                                </div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                    <p v-if="notFunds" class="fs12">
                                        <span class="font999">{{$t('Insufficient_available_balance')}}</span>
                                        <span class="underline pointer" @click="depostHandel(1)">{{$t('Now_deposit')}}</span>
                                    </p>
                                    <template v-else>
                                        <p v-if="mamAccountList.length">
                                            <span class="font999">{{$t('available_balance')}}</span> ${{usableBalance || 0}}
                                        </p>
                                        <p v-else>
                                            <span class="font999">{{$t('Unavailable_account')}}</span>
                                            <span class="underline pointer" @click="openAccountHandle">{{$t('Now_open_an_account')}}</span>
                                        </p>
                                    </template>
                                </el-form-item>
                                <el-form-item prop="trusteeship">
                                    <p class="self-label fs12">{{$t('Manage_funds')}}</p>
                                    <el-input
                                            :placeholder="phFileter($t('Please_enter_a_multiple_of_10'),self)"
                                            :value="mamForm.trusteeship"
                                            @input="trusteeshipInputHandle"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <p class="self-label fs12">{{$t('User.payType')}}</p>
                                    <pay-way
                                      :management-fee="managementFee"
                                      :profots="profots"
                                    ></pay-way>
                                </el-form-item>
                                <el-form-item>
                                    <span class="fs12">{{$t('management_fee')}}: {{managementCost || '-'}}</span>
                                </el-form-item>
                                <el-form-item>
                                    <p class="self-label fs12">{{$t('The_account_to_pay_the_management_fee')}}</p>
                                    <el-input disabled :value="walletInfo.login"></el-input>
                                    <p v-if="enoughWalletBalance">
                                        <span class="">{{$t('available_balance')}}</span>
                                        <span class="master-moeny"> ${{walletInfo.balance}}</span>
                                    </p>
                                    <p v-else>
                                        <span>{{$t('Insufficient_available_balance')}}</span>
                                        <span class="btn-span pointer theme-font"
                                              @click="depostHandel(2)"
                                        >{{$t('Now_deposit')}}</span>
                                    </p>
                                </el-form-item>
                                <el-form-item>
                                    <el-checkbox
                                            v-model="mamForm.autoRenew"
                                    >{{$t('Automatic_renewal')}}</el-checkbox>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                                v-if="step == 2"
                                class="second-step">
                            <div
                                    class="second-step-title blod"
                            >{{$t('Charge_information_confirmation')}}</div>
                            <pay-way
                              :management-fee="managementFee"
                              :profots="profots"
                            ></pay-way>
                            <div class="info-box">
                                <div class="info-line">
                                    <span class="info-line-text">{{$t('Master_account_special')}}</span>
                                    <span class="info-line-border"></span>
                                    <span class="info-line-data">{{masterLogin}}</span>
                                </div>
                                <div class="info-line">
                                    <span class="info-line-text">{{$t('Investment_account')}}</span>
                                    <span class="info-line-border"></span>
                                    <span class="info-line-data">{{mamSubMt4}}</span>
                                </div>
                                <div class="info-line">
                                    <span class="info-line-text">{{$t('Manage_funds')}}</span>
                                    <span class="info-line-border"></span>
                                    <span class="info-line-data">${{mamForm.trusteeship}}</span>
                                </div>
                                <div class="info-line">
                                    <span class="info-line-text">{{$t('management_fee')}}</span>
                                    <span class="info-line-border"></span>
                                    <span class="info-line-data theme-font">${{managementCost}}</span>
                                </div>
                                <div class="info-line">
                                    <span class="info-line-text">{{$t('Automatic_renewal')}}</span>
                                    <span class="info-line-border"></span>
                                    <span class="info-line-data">{{mamForm.autoRenew ? $t('Yes'): $t('Not')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="footer-box">
                <div
                        class="first-step-done"
                     v-show="step == 1"
                >
                    <el-checkbox
                            v-model="mamForm.agree"
                    >{{$t('You_have_read_and_agree')}}
                    </el-checkbox>
                    <span
                    >
                        <a
                                class="theme-font pointer"
                                :href="computedFile"
                                target="_blank"
                        >《{{$t('Documentary_agreement')}}》</a>
                    </span>
                    <div class="btn-box">
                        <el-button
                                :disabled="!mamForm.agree"
                                class="next-btn step-btn"
                                type="primary"
                                @click="nextStepHandle"
                        >{{$t('root.next')}}</el-button>
                    </div>
                </div>
                <div
                        v-show="step == 2"
                        class="second-step-done"
                >
                    <el-button
                            :loading="loading"
                            class="step-btn"
                            type="primary"
                            @click="mamCopySubmitHandle"
                    >{{$t('User.moneyConfirm')}}</el-button>
                    <div class="prev-btn" @click="step = 1">{{$t('root.upper')}}</div>
                </div>
            </div>
            <div class="need-pass pa"
                 v-if="passFlag"
            >
                <div class="title">{{$t('Subscription_password')}}</div>
                <el-form
                        ref="passform"
                        :model="passForm"
                        :rules="passRules"
                >
                    <el-form-item prop="pass">
                        <el-input
                                :placeholder="phFileter($t('Please_enter_your_subscription_password'), self)"
                                @keydown.enter="submitPassHandle"
                                v-model="passForm.pass"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <el-button
                        type="primary"
                        class="pass-submit-btn"
                        @click="submitPassHandle"
                >{{$t('User.moneyConfirm')}}</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import payWay from "@/components/common/mamSubscriptDialog/payWay";
    import { noZeroInit,amountInputValidate } from '@/utils/validate'
    import { queryMasterTraderInfo,checkCopyPassword,addSubscription } from '@/api/copy.js'
    import { mapGetters } from 'vuex'
    import { queryAccountLimit,mtAccList } from '@/api/userCenter.js';
  export default {
    name: 'mamSubscrpitDialog',
    components:{
      payWay
    },
    data() {
      let _this = this;
      var trusteeshipValidate = (rule, value, callback) => {
        if (((+value) % 10) == 0) {
          if(value > this.usableBalance){
            callback(new Error(_this.$t('The_funds_under_management_must_not_exceed_the_account_balance')));
          }else {
            if(this.moneyLimit && value < this.moneyLimit){
              callback(new Error(_this.$t('Not_less_than_the_minimum_funds_under_management')));
            }else {
              callback();
            }
          }
        } else {
          callback(new Error(_this.$t('Please_enter_a_multiple_of_10')));
        }
      };
      return {

        loading: false,
        alias: '',
        moneyLimit: 0,
        passForm:{
          pass: '',
        },
        passRules:{
          pass: [
            {required: true, message: _this.$t('Please_enter_password'), trigger: 'blur'}
          ]
        },
        passwordPass: false,
        walletInfo: {
          login: '',
          balance: '',
        },
        mamForm:{
          mamMt4: '',
          trusteeship: '',
          autoRenew: false,
          agree: false,
        },
        mamAccountList:[],
        mamRules:{
          mamMt4:[
            { required: true, message: _this.$t('Please_select_a_MAM_account'), trigger: 'blur' }
          ],
          trusteeship:[
            { required: true, message: _this.$t('Please_enter_managed_funds'), trigger: 'blur' },
            { validator: trusteeshipValidate,trigger: 'blur' }
          ],
        },
        profots: [],
        masterLogin: '',
        mastAccountMoney: '',
        administrativeFee: '',
        step: 1,
        managementFee: 0,
        passFlag: false,
        self:{},
      };
    },
    created(){
      this.self = this;
    },
    watch:{
      mamSubscrpitDialogShow(newValue){
        if(newValue){
          this.passForm.pass = '';
          this.step = 1;
          this.$refs.passform && this.$refs.passform.clearValidate();
          this.queryTraderInfo();
          this.queryMoneyAccount();
        }else {
          // 重置form表单的值
          this.resetForm();
          this.$store.commit('setMamSubEditSubscrpitParams', {
            trusteeship: '',
            mamMt4: '',
            autoRenew: false,
            ids: '',
          })
        }
      },
      mamSubEditSubscrpitParams(val){
        if(val.trusteeship){
          this.mamForm.trusteeship = val.trusteeship;
          this.mamForm.mamMt4 = val.mamMt4;
          this.mamForm.autoRenew = val.autoRenew;
        }
      }
    },
    computed: {
      ...mapGetters(['mamSubscrpitDialogShow','userInfo','agreementFile','agreementFileEn','listRefresh','currentMasterMtId','language','openAccountDialogShow']),
      managementCost(){
        if((this.mamForm.trusteeship % 10) == 0){
          return (this.mamForm.trusteeship * (parseFloat(this.managementFee) / 100)).toFixed(2);
        }else {
          return '-';
        }
      },
      notFunds(){
        let flag = false;
        for (let i = 0; i <this.mamAccountList.length ; i++) {
          if(this.mamForm.mamMt4 == this.mamAccountList[i].copyMtId){
            if(this.mamAccountList[i].copyBalances == 0){
              flag = true;
            }
          }
        }
        return flag;
      },
      usableBalance(){
        let money = 0;
        for (let i = 0; i <this.mamAccountList.length ; i++) {
          if(this.mamForm.mamMt4 == this.mamAccountList[i].copyMtId){
            money = this.mamAccountList[i].copyBalances;
          }
        }
        return money;
      },
      mamSubMt4(){
        for (let i = 0; i <this.mamAccountList.length ; i++) {
          if(this.mamForm.mamMt4 == this.mamAccountList[i].copyMtId){
            return this.mamAccountList[i].copyLogin;
          }
        }
      },
      enoughWalletBalance(){
        if(parseFloat(this.managementFee) === 0){
          return true;
        }
        if(!noZeroInit(this.mamForm.trusteeship) || this.mamForm.trusteeship < 10){
          return true
        }else {
          if(this.walletInfo.balance > this.managementCost ){
            return true;
          }else {
            return false;
          }
        }
      },
      computedFile(){
        if(this.language == 'zh_CN'){
          return this.agreementFile;
        }else {
          return this.agreementFileEn;
        }
      },

    },
    methods: {
      phFileter(data){
        return this.$t(data);
      },
      trusteeshipInputHandle(val){
        this.mamForm.trusteeship = amountInputValidate(val, 'managedFund');
      },
      queryMoneyAccount(){
        mtAccList({
          id: this.userInfo.id,
          businessTypes: 3
        }).then((res) => {
          if(res.data.length){
            this.walletInfo = res.data[0];
          }
        })
      },
      openAccountHandle(){
        queryAccountLimit({
          custId: this.userInfo.id,
        }).then((res) => {
          if(res.data === 0){
            this.$message({
              message: this.$t('Account_number_has_reached_maximum_limit'),
              type: 'warning'
            });
            return;
          }else {
            this.closeHandle();
            this.$store.commit('setOpenAccountDialogShow', true);
            this.$store.commit('setOpenAccountRole', 5);
          }
        })
      },
      queryTraderInfo(){
        queryMasterTraderInfo({
          masterMtId: this.currentMasterMtId,
          isCreate: true,
        }).then((res) => {
          this.masterLogin = res.data.content[0].masterLogin;
          this.alias = res.data.content[0].alias;
          this.passFlag = res.data.content[0].isPassword == 1 ? true: false;
          this.moneyLimit = res.data.content[0].subAmount;
          this.mamAccountList = res.data.copyLogins;
          if(this.mamAccountList.length){
            this.mamForm.mamMt4 = this.mamAccountList[0].copyMtId;
          }
          this.managementFee = res.data.content[0].price;
          if(res.data.profits && res.data.profits.length){
            this.profots = res.data.profits;
          }
        })
      },

      closeHandle() {
        this.$store.commit('setMamSubscrpitDialogShow', false);
      },
      submitPassHandle(){
        this.$refs.passform.validate((valid) => {
          if(valid){

            checkCopyPassword({
              password: this.passForm.pass,
              masterMtId: this.currentMasterMtId,
            }).then((res) => {
              if(res.data.content[0]){
                this.passFlag = false;
              }else {
                this.$message({
                  type: 'warning',
                  message: this.$t('wrong_password')
                })
              }
            });

          }else {
            console.log('error 请输入密码');
          }
        })
      },
      depostHandel(number){
        let mastAccount = '';
        if(this.number == 1){
          mastAccount = this.mamSubMt4;
        }else {
          mastAccount = this.walletInfo.login;
        }
        this.$store.commit('setDepositAccount', mastAccount);
        this.closeHandle();
        this.$router.push({name: 'depositFunds'});
      },
      nextStepHandle(){
        this.$refs.mamform.validate((valid) => {
          if(valid){
            this.step = 2;
          }else {

          }
        })

      },
      mamCopySubmitHandle(){
        let params = {
          copyMtId: this.mamForm.mamMt4,
          masterMtId: this.currentMasterMtId,
          subscriptionType: 1,
          isRenew: this.mamForm.autoRenew == true ? 1 : 0,
          managementAmount: this.mamForm.trusteeship,
        };
        this.loading = true;
        addSubscription(params).then((res) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: this.$t('Subscribe_to_the_success')
          });
          this.$store.commit('setListRefresh',!this.listRefresh);
          setTimeout(() => {
           this.closeHandle();
          },1000);
        }).catch((error) => {
          this.loading = false;
        });
      },
      resetForm(){
        this.mamForm = {
          mamMt4: '',
          trusteeship: '',
          autoRenew: false,
          agree: false,
        };
        this.$refs.mamform && this.$refs.mamform.clearValidate();
      }
    }
  };
</script>
<style lang="scss">
    .open-account-drawer  {
        .el-select{
            width: 100%;
        }
    }
</style>
<style lang="scss" scoped>
    @import "../../../../assets/scss/variable.scss";
    .drawer-content {
        height: calc(100vh - 64px - 100px);
        &.need-pass {
            height: calc(100vh - 64px);
        }
        border-top: 1px solid #E6E6E6;
    }
    .el-select-dropdown__list {
        padding-bottom: 10px;
    }
    .el-select-dropdown__item {
        height: auto;
        line-height: normal;
    }
    .option-tag {
        background-color: rgba(240,138,93, .1);
        color: #F08A5D;
    }
    .footer-box {
        padding: 10px 20px;
    }
    .self-option-item {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .self-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .subscript-box {
        padding: 20px;
        .copytype-title {
            margin-bottom: 5px;
        }
        .mam-info {
            background-color: #F6F8FA;
            padding: 15px;
            margin-bottom: 25px;
            .nickname {
                font-size: 14px;
                color: #333333;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .money-limit {
                color: #999999;
            }
        }

        .second-step {
            .second-step-title {
                color: #333333;
                font-size: 14px;
                margin-bottom: 20px;
            }
            .info-box {
                margin-top: 20px;
                font-size: 14px;
                color: #333333;
                .info-line {
                    margin-bottom: 18px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .info-line-border {
                        flex: 1;
                        border-bottom: 1px solid #999999;
                    }
                    .info-line-text {
                        margin-right: 5px;
                    }
                    .info-line-data {
                        margin-left: 5px;
                    }
                }
            }
        }
    }

    .price-desc {
      line-height: 1.5;
      margin-bottom: 15px;
    }
    .step-btn {
        width: 100%;
    }
    .next-btn {
        margin-top: 20px;
    }
    .prev-btn {
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
    }
    .need-pass {
        width: 100%;
        height: 100%;
        z-index: 99;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, .9);
        padding: 50px 30px;

        .title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        .pass-submit-btn {
            width: 100%;
        }
    }

</style>
